import * as Styled from './Form.styled';
import { FormOrientation, type FormProps } from './Form.types';

export const Form = ({
  children,
  className,
  handleSubmit,
  orientation = FormOrientation.Block,
  validationErrors,
  withLabels = false,
}: FormProps) => (
  <Styled.Form
    $orientation={orientation}
    $withLabels={withLabels}
    className={className}
    onSubmit={handleSubmit}
    validationErrors={validationErrors}
  >
    {children}
  </Styled.Form>
);
